import { Button } from "primereact/button";
import { useAppDispatch, useAppSelector } from "../../hooks/storeHooks";
import { useCallback } from "react";
import { selectInspectionIsDisabled } from "../../store/selectors/inspectionSelectors";
import { PositiveItem } from "../../types/positiveItem";
import { setToEdit } from "../../store/slices/positiveItemSlice";

export const PositiveItemTableActionsBody = (positiveItem: PositiveItem) => {
    const dispatch = useAppDispatch();

    const inspectionDisabled = useAppSelector(selectInspectionIsDisabled);

    const onEdit = useCallback(() => {
        dispatch(setToEdit(positiveItem));
    }, [positiveItem]);

    return (
        <div className="flex">
            <Button
                icon="pi pi-pencil"
                rounded
                text
                onClick={onEdit}
                disabled={inspectionDisabled}
                tooltip="Edit"
                tooltipOptions={{ position: "top" }}
            />
        </div>
    );
};
